// extracted by mini-css-extract-plugin
export default {"tooltip":"TP-z","arrow":"UP-z"};